import React from "react";
import { withStyles, Button } from "@material-ui/core";
import { Refresh } from "@material-ui/icons";
import { withSnackbar } from "notistack";
import { compose } from "recompose";
import { getDataWithQueryString } from "../../../../api/componentAPIs";
import SearchBox from "../../../common/SearchBox";
import DataGrid from "../../../dataGrid";
import styles from "../../Settings/styles";
import GridConfig from "./GridConfig";
import ClearAllFilterButton from "../../../dataGrid/columnFilters/ClearAllFilterButton";

class ShipmentsEventStream extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      stagingEventsData: null,
      id: new Date().toString(),
    };
    this.gridApi = null;
    this.gridConfig = new GridConfig();
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchShipmentEventStreamData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  fetchShipmentEventStreamData = () => {
    this.setState({
      id: new Date().toString(),
      stagingEventsData: null,
    });
    getDataWithQueryString("GetStagingEvents")
      .then((response) => {
        if (this._isMounted) {
          this.setState({
            stagingEventsData: response.data ?? [],
          });
        }
      })
      .catch(() => {
        this.setState({
          stagingEventsData: [],
        });
        this.props.enqueueSnackbar("Unable to fetch data ", {
          variant: "error",
        });
      });
  };

  updateQuickFilterText = (value) => {
    this.setState({
      quickFilterText: value,
    });
  };

  onCellClick = (params) => {
    if (params.column.colId === "copyIcon") {
      navigator.clipboard
        .writeText(JSON.stringify(params.data.data))
        .then((r) => {
          this.props.enqueueSnackbar("Copied data", { variant: "success" });
        });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <header className={classes.moduleHeader} style={{ borderBottom: 0 }}>
          Events Stream
          <div className={classes.gridActionIcons}>
            <Button
              color="primary"
              variant="contained"
              onClick={this.fetchShipmentEventStreamData}
            >
              <Refresh fontSize="small" />
              Refresh
            </Button>
            <SearchBox onChange={this.updateQuickFilterText} />
            <ClearAllFilterButton gridApi={this.gridApi} />
          </div>
        </header>
        <div className={classes.reportsIBPlanningGridContainer}>
          <div className={`${classes.dataGrid} ${classes.anchorPointContent}`}>
            <DataGrid
              key={this.state.id}
              defaultColDef={this.gridConfig.config.defaultColDef}
              columnDefs={this.gridConfig.config.columns}
              config={this.gridConfig.config}
              rowData={this.state.stagingEventsData}
              quickFilterText={this.state.quickFilterText}
              onGridReady={this.onGridReady}
              rowHeight={120}
              onCellClicked={this.onCellClick}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default compose(withSnackbar, withStyles(styles))(ShipmentsEventStream);
